import Cookies from 'js-cookie'

export function clearUserData(){
	localStorage.removeItem("directPath");
	localStorage.removeItem("rolePermissions");
	localStorage.removeItem("buttonPermissions");
}

export function getToken() {
	return Cookies.get('tokenKey')
}

export function setToken(token) {
	return Cookies.set('tokenKey', token)
}

export function removeToken() {
	Cookies.remove('access_token')
	return Cookies.remove('tokenKey')
}

export function getRefreshToken() {
	return Cookies.get('refreshTokenKey')
}

export function setRefreshToken(refreshToken) {
	return Cookies.set('refreshTokenKey', refreshToken)
}

export function removeRefreshToken() {
	return Cookies.remove('refreshTokenKey')
}

export function setUserInfo(userInfo) {
	Cookies.set('userInfo', userInfo)
}
export function getUserInfo(){
	return Cookies.get('userInfo')
}

export function removeUserInfo() {
	return Cookies.remove('userInfo')
}



// WEBPACK FOOTER //
// ./src/util/auth.js